import React, { useEffect, useState } from 'react'
import NavBar from '../Component/NavBarFooter/NavBar'
import Footer from '../Component/NavBarFooter/Footer'
import Banner from '../Component/ScholarshipPage/Banner'
import ScholarshipLisit from '../Component/ScholarshipPage/ScholarshipLisit'
import { useAuth } from '../Context/ContextProvider'
import { useLocation } from 'react-router-dom'

function ScholarshipPage() {
    const { getScholarships, parseQueryParams } = useAuth()
    const [scholarshipList, setScholarshipList] = useState([])
    const [pagination, setPagination] = useState(null)
    const [filterData, setFilterData] = useState({
        keyword: "",
        city_code: "",
    })

    const handlePageChange = (pageAction) => {
        let goPage = filterData?.current_page || 1;

        if (pageAction?.action === "next" && pagination?.has_next_page) {
            goPage = filterData?.current_page + 1;
        }

        if (pageAction?.action === "back" && pagination?.has_prev_page) {
            goPage = filterData?.current_page - 1;
        }

        if (pageAction?.action === "pageChange") {
            goPage = pageAction?.page_number;
        }

        if (pageAction?.action === "perPageChange") {
            goPage = 1; // Reset to first page when changing per page
        }

        // Update current page in state - useEffect will handle the fetch
        const newFilterData = { ...filterData, current_page: goPage };
        if (pageAction?.action === "perPageChange") {
            newFilterData.per_page = pageAction?.per_page;
        }
        setFilterData(newFilterData);
    }
    const location = useLocation()
    useEffect(() => {
        const fetchScholarships = async () => {
            const parsed = parseQueryParams(location.search);
            setFilterData(parsed);
            const resp = await getScholarships(parsed)
            if (resp.success) {
                setScholarshipList(resp?.data?.scholarships)
                setPagination(resp?.data?.pagination)
            }
        }
        fetchScholarships()
    }, [location.search])

    return (
        <div>
            <NavBar />
            <Banner filterData={filterData} setFilterData={setFilterData} />
            <ScholarshipLisit
                scholarshipList={scholarshipList}
                pagination={pagination}
                handlePageChange={handlePageChange}
                filterData={filterData}
            />
            <Footer />
        </div>
    )
}

export default ScholarshipPage